import { render, staticRenderFns } from "./LabelPriceList.vue?vue&type=template&id=c94b4546&scoped=true&"
import script from "./LabelPriceList.vue?vue&type=script&lang=js&"
export * from "./LabelPriceList.vue?vue&type=script&lang=js&"
import style0 from "./LabelPriceList.vue?vue&type=style&index=0&id=c94b4546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94b4546",
  null
  
)

export default component.exports